import { render, staticRenderFns } from "./tabTradeCommission.vue?vue&type=template&id=775294f9&scoped=true&"
import script from "./tabTradeCommission.vue?vue&type=script&lang=js&"
export * from "./tabTradeCommission.vue?vue&type=script&lang=js&"
import style0 from "./tabTradeCommission.vue?vue&type=style&index=0&id=775294f9&scoped=true&lang=scss&"
import style1 from "./tabTradeCommission.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775294f9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('775294f9')) {
      api.createRecord('775294f9', component.options)
    } else {
      api.reload('775294f9', component.options)
    }
    module.hot.accept("./tabTradeCommission.vue?vue&type=template&id=775294f9&scoped=true&", function () {
      api.rerender('775294f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaImport/components/SiBooking/tabs/tabTradeCommission.vue"
export default component.exports